import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {forkJoin, map, Observable, of, switchMap} from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({providedIn: 'root'})
export class EventService {
    constructor(private http: HttpClient) {}
    getEventDetails(id: any, year: Number): Observable<any> {
        const credentials = btoa(`${environment.username}:${environment.apikey}`);
        const headers = new HttpHeaders({
            'Authorization': `Basic ${credentials}`,
            'Accept': 'application/json'
        });

        const baseUrl = `${environment.apiUrl}/v3.2/${year}/rankings/regional/eventdetail/${id}`;

        return this.http.get<any>(`${baseUrl}?page=1`, { headers }).pipe(
            switchMap(firstPage => {
                if(firstPage.eventStatus == 'NotStarted'){
                    return of({
                        ...firstPage,
                        teamDetails: null
                    });
                }
                else {
                    const pageSize = firstPage.teamCountPage;
                    const totalItems = firstPage.teamCountTotal;

                    const totalPages = Math.ceil(totalItems / pageSize);

                    // extract page 1 team details
                    const allDetails = [...firstPage.teamDetails];

                    // if only one page, return
                    if (totalPages === 1) {
                        return of({
                            ...firstPage,
                            teamDetails: allDetails
                        });
                    }

                    // build requests for page number higher than 1
                    const requests: Observable<any>[] = [];
                    for (let page = 2; page <= totalPages; page++) {
                        requests.push(
                            this.http.get<any>(`${baseUrl}?page=${page}`, { headers })
                        );
                    }
                    // merge the arrays
                    return forkJoin(requests).pipe(
                        map(responses => {
                            responses.forEach(page => {
                                if (Array.isArray(page.teamDetails)) {
                                    allDetails.push(...page.teamDetails);
                                }
                            });

                            // Return SAME structure but with full merged teamDetails
                            return {
                                ...firstPage,
                                teamDetails: allDetails
                            };
                        })
                    );
                }
            })
        );
    }


    getAllEventsData(year:any): Observable<any> {
        const credentials = btoa(`${environment.username}:${environment.apikey}`);
        const headers = new HttpHeaders({
            'Authorization': `Basic ${credentials}`,
            'Accept': 'application/json'
        });
        return this.http.get(environment.apiUrl + '/v3.2/' + year + '/events', {headers}).pipe(map(res => res));
    }

    getCurrentEventSeason(): Observable<any> {
        const credentials = btoa(`${environment.username}:${environment.apikey}`);
        const headers = new HttpHeaders({
            'Authorization': `Basic ${credentials}`,
            'Accept': 'application/json'
        });
        return this.http.get(environment.apiUrl + '/apistatus/', {headers}).pipe(map(res => res));
    }
}
